import type { UseDocumentProps } from '@ztechapps/common.hook'
import { useDocument } from '@ztechapps/common.hook'
import type { WorkOrder } from '@ztechapps/common.contract'
import { useWorkOrderIdParam } from './useWorkOrderIdParam'
import { workOrderDocumentQueries } from './graphql'

export const useWorkOrderDocument = ({ query, ...props } = {} as Partial<UseDocumentProps>) => {
  const _id = useWorkOrderIdParam()

  query = query ?? workOrderDocumentQueries.singleConfig.query

  return useDocument<WorkOrder>({ query, _id, ...props })
}
